<template>
  <div>
    <div class="cantainer">
      <my-tab1 :title="title"></my-tab1>
      <img :src="bj" alt="" class="cantainer-img">
      <div class="content  top">
        <my-tab2 :is-list="false" class="right"></my-tab2>
        <my-Content class="right"></my-Content>
      </div>
    </div>
    <my-end class="top"></my-end>
  </div>
</template>
<script>
import Tab1 from '@/components/tabs/tabs1'
import Tab2 from '@/components/tabs/tabs2'
import End from '@/components/End-text'
import Content from '@/components/Content'
import dian from '@/assets/bj.png'
import axios from "axios";
import {orgId, requestUrl} from "../common/cons";
export default {
  name: "NewsContent",
  components:{
    'my-tab1':Tab1,
    'my-tab2':Tab2,
    'my-end':End,
    'my-Content':Content
  },
  data(){
    return{
      bj:dian,
      title:[]
    }
  },
  created() {
    this.init()
  },
  methods:{
    async init () {
      await this.queryNavList()
    },
    async queryNavList(){
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      this.title=result.data
    }
  }
}
</script>

<style scoped>

.cantainer{
width: 100%;
  display: flex;
  flex-direction: column;
}
.top{
  margin-top: 20px;
}
.left{
  margin-left: 40px;
}
.right{
  margin-right: 40px;
}
.cantainer-img{
  width: 100%;
  height: 180px;
  margin-top: 20px;
}
.content{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/NewsContent.vue